import { render, staticRenderFns } from "./TopPlacementEditor.vue?vue&type=template&id=2655887c&scoped=true&"
import script from "./TopPlacementEditor.vue?vue&type=script&lang=js&"
export * from "./TopPlacementEditor.vue?vue&type=script&lang=js&"
import style0 from "./TopPlacementEditor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TopPlacementEditor.vue?vue&type=style&index=1&id=2655887c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2655887c",
  null
  
)

export default component.exports